import React, { ReactElement } from "react";
import { IconX } from "@tabler/icons-react";
import ButtonStyled from "./ButtonStyled";

type Props = {
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  title: string;
  children: React.ReactNode;
  actionButtonText: string | React.ReactElement | false | undefined;
  open: boolean;
  actionButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
  cancelButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
  actionButtonExtraClasses?: string | undefined;
  actionButtonProps?: React.ComponentProps<"button">;
  actionButtonIcon?: ReactElement | false | undefined;
  closeButtonText?: string;
  hideFooter?: boolean;
  isPending?: boolean;
  showFooter?: boolean;
};

const CommonModal = (props: Props) => {
  return (
    <>
      {props.open && (
        <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
          <div className="bg-[#F7F6F2] rounded-2xl max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between px-4 py-4 border-b border-[#d2d2d2] flex-shrink-0">
              <h1 className="text-2xl">{props.title}</h1>
              <button
                onClick={props.onClose}
                className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer"
              >
                <IconX size={20} />
              </button>
            </div>
            <div className="overflow-y-auto flex-grow">
              {props.children}
            </div>
            {!props.hideFooter && (
              <div className="border-t border-[#D8D8D8] px-4 py-4 flex justify-end space-x-2 flex-shrink-0">
                {/* <button
                  className="border border-[#D8D8D8]  bg-transparent flex items-center rounded-full p-2 px-4 space-x-1 cursor-pointer text-base font-medium "
                  onClick={props.cancelButtonOnClick ?? props.onClose}
                >
                  {props.closeButtonText}
                </button> */}
                <ButtonStyled
                  value={props?.actionButtonText}
                  onClick={props.actionButtonOnClick}
                  extraClasses={props.actionButtonExtraClasses}
                  extraProps={props.actionButtonProps}
                  icon={props.actionButtonIcon}
                  isPending={props?.isPending}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CommonModal;
